import { useNavigate } from 'react-router-dom';
import HorizontalSteps from '../../../components/horizontalSteps';
import { useEffect, useRef } from 'react';
import html2canvas from 'html2canvas';
import { Certificate } from '../../../components/certificate';
import { steps } from '../../../cont';
// import CertificateDownload from '../../../components/certificate_download';
// import { IoLogoWhatsapp } from 'react-icons/io';
// import { FaLinkedinIn } from 'react-icons/fa';
// import { MdMail } from 'react-icons/md';
// import { AiFillInstagram } from 'react-icons/ai';
// import { FaXTwitter } from 'react-icons/fa6';
// import { FaFileDownload } from "react-icons/fa";

type props = {
  orderId: String;
  orderDate: String;
  orderedBy: String;
  certificateLink: string;
};

function ConfirmationPage({
  orderId,
  orderDate,
  orderedBy,
  certificateLink,
}: props) {
  // const [showShareModal, setShowShareModal] = useState(false);
  const navigate = useNavigate();
  const certificateRef = useRef(null);
  const newCertificateRef = useRef(null);

  const waitForFonts = async () => {
    if (document.fonts && document.fonts.ready) {
      await document.fonts.ready;
    }
  };

  const generateImage = async () => {
    await waitForFonts();

    if (newCertificateRef.current) {
      const canvas = await html2canvas(newCertificateRef.current, {
        scale: 3,
        useCORS: true,
      });
      return new Promise((resolve) => {
        canvas.toBlob((blob) => {
          if (blob) {
            resolve(blob);
          } else {
            resolve(null);
          }
        }, 'image/png');
      });
    }
    return null;
  };

  const downloadHTMLImage = async () => {
    const blob = await generateImage();
    if (blob) {
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob as any);
      link.href = url;
      link.download = 'pixa_birth_certificate.png';
      link.click();
      URL.revokeObjectURL(url);

      const uploadPromise = uploadToCloudinary(blob as any);
      uploadPromise.then((generatedCertificateLink) => {
        // NOTE: certificateLink here is transactionId with wrong name
        updateOrder(orderId, certificateLink, generatedCertificateLink, false);
      });
    }
  };

  const uploadToCloudinary = async (blob: Blob) => {
    const formData = new FormData();
    formData.append('file', blob);
    formData.append('upload_preset', 'jqxvrog3');

    const response = await fetch(
      'https://api.cloudinary.com/v1_1/dx6dieevo/image/upload',
      {
        method: 'POST',
        body: formData,
      }
    );

    const data = await response.json();
    console.log('The url is: ', data.secure_url, 'for the order Id: ', orderId);
    return data.secure_url;
  };

  const autoUploadToCloudinary = async (blob: Blob) => {
    const formData = new FormData();
    formData.append('file', blob);
    formData.append('upload_preset', 'jqxvrog3');

    const response = await fetch(
      'https://api.cloudinary.com/v1_1/dx6dieevo/image/upload',
      {
        method: 'POST',
        body: formData,
      }
    );

    const data = await response.json();
    console.log('The url is: ', data.secure_url, 'for the order Id: ', orderId);
    return data.secure_url;
  };

  const updateOrder = async (
    orderId: String,
    transactionId: String,
    generatedCertificateLink: String,
    need_mail: boolean = false
  ) => {
    const paymentWebhookAPI =
      'https://kmvxejomsbmklyrgkgzj.supabase.co/functions/v1/pixa-razorpay-webhook';
    const response = await fetch(paymentWebhookAPI, {
      method: 'PUT',
      headers: {
        Authorization:
          'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imttdnhlam9tc2Jta2x5cmdrZ3pqIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTcxMzM0NTc2OSwiZXhwIjoyMDI4OTIxNzY5fQ.7abVoPmLVABLdO-QmQvb8LzCZeP5X8kcOPARfNnh690',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        orderId: orderId,
        transactionId: transactionId,
        certificateLink: generatedCertificateLink,
        need_mail: need_mail,
      }),
    });

    if (!response.ok) {
      console.log('There was an error updating the order');
    }

    const updatedOrderData = await response.json();
    return updatedOrderData;
  };

  // const shareImage = async (platform: string) => {
  //   // const imageData = await generateImage();
  //   if (certificateLink) {
  //     let shareUrl = '';
  //     const text = 'Check out my Pixa AI Birth Certificate!';
  //     const encodedText = encodeURIComponent(text);

  //     // const uploadedImageUrl = await uploadToCloudinary(imageData);

  //     // if (!uploadedImageUrl) {
  //     //   alert('Image upload failed. Please try again.');
  //     //   return;
  //     // }

  //     switch (platform) {
  //       case 'whatsapp':
  //         shareUrl = `https://api.whatsapp.com/send?text=${encodedText}%20${certificateLink}`;
  //         break;
  //       case 'linkedin':
  //         shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${certificateLink}&title=${encodedText}`;
  //         break;
  //       case 'email':
  //         shareUrl = `mailto:?subject=${encodedText}&body=${encodedText}%20${certificateLink}`;
  //         break;
  //       // case 'instagram':
  //       //   alert('Instagram sharing is not directly supported. Please download the image and share it manually on Instagram.');
  //       //   return;
  //       case 'twitter':
  //         shareUrl = `https://twitter.com/intent/tweet?text=${encodedText}&url=${certificateLink}`;
  //         break;
  //       case 'download':
  //         downloadImage();
  //         break;
  //       default:
  //         break;
  //     }

  //     if (shareUrl) {
  //       window.open(shareUrl, '_blank');
  //     }
  //   }
  // };

  useEffect(() => {
    const link1 = document.createElement('link');
    link1.href =
      'https://fonts.googleapis.com/css2?family=Gochi+Hand&display=swap';
    link1.rel = 'stylesheet';
    document.head.appendChild(link1);

    const link2 = document.createElement('link');
    link2.href =
      'https://fonts.googleapis.com/css2?family=Modern+Antiqua&display=swap';
    link2.rel = 'stylesheet';
    document.head.appendChild(link2);

    const link3 = document.createElement('link');
    link3.href =
      'https://fonts.googleapis.com/css2?family=Just+Me+Again+Down+Here&display=swap';
    link3.rel = 'stylesheet';
    document.head.appendChild(link3);

    return () => {
      document.head.removeChild(link1);
      document.head.removeChild(link2);
      document.head.removeChild(link3);
    };
  }, []);

  useEffect(() => {
    const generateAndUpload = async () => {
      const blob = await generateImage();
      if (blob) {
        const generatedCertificateLink = await autoUploadToCloudinary(
          blob as any
        );
        if (generatedCertificateLink) {
          const orderUdpated = await updateOrder(
            orderId,
            certificateLink,
            generatedCertificateLink,
            false
          );
          if (orderUdpated !== null || orderUdpated !== undefined) {
            console.log('Order updated successfully');
            console.log(
              'The certificate link generated and uploaded is: ',
              generatedCertificateLink
            );
          }
        }
      }
    };
    generateAndUpload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [certificateLink, orderId]);

  return (
    <>
      <div className="flex flex-col min-h-screen w-full justify-start items-center text-center py-8 max-md:py-8 bg-[#F1F3F6] z-10">
        <div className="flex flex-col justify-center text-center items-center text-4xl max-md:text-3xl max-xs:text-3xl mt-4 max-md:mt-4 w-[80vw] xl:w-[60vw] text-[#101828] font-[700]">
          <span className="relative">Woohoo! Your order is confirmed</span>
        </div>
        <div className="flex justify-center text-center items-center text-lg max-md:text-sm mt-4 text-[#667085] font-[400] w-[50%] max-md:w-[90%]">
          To ensure we deliver the best possible experience, we're taking some
          extra time before shipping.
        </div>
        <div className="w-[90%] mt-8 bg-[#fff] rounded-[24px] flex justify-start items-start p-8 max-md:p-4 flex-col">
          <div className="flex-col flex w-full justify-start mb-8 max-lg:mb-0 items-start text-center">
            <p className="text-3xl font-[700] text-[#101828]">Order details</p>
            {/* <p className="text-sm text-[#667085] font-[400]">
            Order ID: <u>{orderId}</u>
          </p> */}
          </div>
          <div className="w-full flex flex-row max-lg:flex-col justify-start text-center p-8 px-0">
            <div className="flex flex-col justify-start items-start text-center w-[40%] max-lg:w-full">
              <span className="flex flex-row justify-between w-full text-center">
                <div className="flex flex-row justify-start items-start text-center">
                  <img
                    src="https://res.cloudinary.com/dx6dieevo/image/upload/f_auto,q_auto:good,w_auto/v1723733924/pixa-pie/checkout/pie.webp"
                    alt="pie"
                    className="object-cover object-center h-[6.6rem] w-[6.4rem] max-lg:h-[5.2rem] max-lg:w-[5rem] rounded-[1rem]"
                  />
                  <span className="flex flex-col justify-start items-center text-center ml-3">
                    <p className="text-[1.225rem] max-lg:text-[1rem] font-semibold w-full text-left mb-1">
                      Pie
                    </p>
                    <p className="text-[#667085] text-[0.825rem] max-lg:text-[0.725rem] w-full text-left">
                      AI talking friend
                    </p>
                    {/*
                   <p className="text-[#667085] text-[0.825rem] max-lg:text-[0.725rem] w-full text-left">
                    Quantity: 1
                  </p>
                  <p className="text-[#667085] text-[0.825rem] max-lg:text-[0.725rem] w-full text-left">
                    Size: Free size
                  </p> */}
                  </span>
                </div>
                <span className="font-semibold text-[1.325rem] max-lg:text-[1.025rem]">
                  ₹{999}
                </span>
              </span>
              <span className="flex flex-row justify-between w-full text-center mt-4">
                <div className="flex flex-row justify-start items-start text-center">
                  <img
                    src="https://res.cloudinary.com/dx6dieevo/image/upload/f_auto,q_auto:good,w_auto/v1723733926/pixa-pie/checkout/prime-subs.jpg"
                    alt="prime subscription"
                    className="object-cover object-center h-[6.6rem] w-[6.4rem] max-lg:h-[5.2rem] max-lg:w-[5rem] rounded-[1rem]"
                  />
                  <span className="flex flex-col justify-start items-center text-center ml-3">
                    <p className="text-[1.225rem] max-lg:text-[1rem] font-semibold w-full text-left mb-1">
                      Premium subscription
                    </p>
                    {/* <p className="text-[#667085] text-[0.825rem] max-lg:text-[0.725rem] w-full text-left">
                    Quantity: 1
                  </p> */}
                    <p className="text-[#667085] text-[0.825rem] max-lg:text-[0.725rem] w-full text-left">
                      Validity: 3 months
                    </p>
                  </span>
                </div>
                <span className="font-semibold text-[1.325rem] max-lg:text-[1.075rem]">
                  FREE
                </span>
              </span>
            </div>
            <div className="bg-[#D0D5DD] border rounded-[8px] w-[1px] max-lg:w-[100%] flex min-h-[80%] max-lg:min-h-0 max-lg:h-[1px] mx-8 max-lg:mx-0 max-lg:my-8"></div>
            <div className="w-[60%] max-lg:w-full flex flex-col justify-start text-left">
              <span className="flex flex-row justify-start items-center text-left my-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <path
                    d="M11 25.0085C11 25.5389 10.7893 26.0476 10.4142 26.4227C10.0392 26.7977 9.53046 27.0085 9.00002 27.0085C8.46959 27.0085 7.96088 26.7977 7.58581 26.4227C7.21074 26.0476 7.00002 25.5389 7.00002 25.0085M11 25.0085C11 24.478 10.7893 23.9693 10.4142 23.5942C10.0392 23.2192 9.53046 23.0085 9.00002 23.0085C8.46959 23.0085 7.96088 23.2192 7.58581 23.5942C7.21074 23.9693 7.00002 24.478 7.00002 25.0085M11 25.0085H19M7.00002 25.0085H4.50002C4.1022 25.0085 3.72067 24.8504 3.43936 24.5691C3.15806 24.2878 3.00002 23.9063 3.00002 23.5085V19.0085M19 25.0085H22M19 25.0085V19.0085M3.00002 19.0085V8.82845C2.99791 8.46334 3.13131 8.11043 3.37441 7.83802C3.61751 7.56561 3.95303 7.39306 4.31602 7.35378C8.76009 6.89249 13.24 6.89249 17.684 7.35378C18.4374 7.43112 19 8.07112 19 8.82845V10.1058M3.00002 19.0085H19M26 25.0085C26 25.5389 25.7893 26.0476 25.4142 26.4227C25.0392 26.7977 24.5305 27.0085 24 27.0085C23.4696 27.0085 22.9609 26.7977 22.5858 26.4227C22.2107 26.0476 22 25.5389 22 25.0085M26 25.0085C26 24.478 25.7893 23.9693 25.4142 23.5942C25.0392 23.2192 24.5305 23.0085 24 23.0085C23.4696 23.0085 22.9609 23.2192 22.5858 23.5942C22.2107 23.9693 22 24.478 22 25.0085M26 25.0085H27.5C28.328 25.0085 29.0054 24.3365 28.9534 23.5098C28.6854 19.1066 27.2026 14.8639 24.6694 11.2525C24.4281 10.9142 24.113 10.6351 23.7481 10.4365C23.3831 10.2378 22.9778 10.1248 22.5627 10.1058H19M19 10.1058V19.0085"
                    stroke="#475467"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <p className="text-[1.225rem] max-lg:text-[1.115rem] text-[#475467] font-[600] ml-2 mt-1">
                  Tracking status
                </p>
              </span>
              <HorizontalSteps steps={steps} orderDate={orderDate} />
              <div className="relative lg:hidden">
                {steps.map((step: any, index: any) => (
                  <div
                    key={step.id}
                    className="lg:mb-8 max-lg:mb-6 max-sm:mb-4"
                  >
                    <div className="flex items-center mb-2">
                      <div
                        className={`w-8 h-8 text-white rounded-full flex items-center justify-center text-xl z-10 p-1 ${
                          index + 1 < 2
                            ? 'bg-[#6BBD64]'
                            : 'bg-[#fff] border-4 border-[#CCD1DA]'
                        }`}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="38"
                          height="38"
                          viewBox="0 0 38 38"
                          fill="none"
                        >
                          <path
                            d="M7 20.7132L15 28.7132L31 11.5703"
                            stroke="white"
                            stroke-width="3.42857"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="ml-2 max-lg:ml-1.5 font-semibold text-[#202020] text-[1rem] -mt-0.5">
                        {step.name}
                      </div>
                    </div>
                    <div className="ml-10 bg-[#fff] lg:p-2 rounded-lg max-sm:py-4 -mt-6 max-lg:-mt-2 max-md:-mt-6 text-left space-y-2 flex flex-col">
                      {index + 1 < 2 ? (
                        <span className="text-[#667085] text-xs">
                          {orderDate}
                        </span>
                      ) : (
                        <span className="text-[#667085] text-xs">
                          {step.duration}
                        </span>
                      )}
                    </div>
                    {index === 2 ? (
                      <div className="absolute w-1 h-[20%] top-0.5 left-5 max-lg:left-3.5 bg-[#6BBD64] z-[9]"></div>
                    ) : (
                      <div className="absolute w-1 h-[80%] top-0.5 left-5 max-lg:left-3.5 bg-[#CCD1DA]"></div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div
          className="w-[90%] mt-8 bg-[#fff] rounded-[24px] flex justify-center items-center p-8 max-md:p-4 flex-col bg-cover max-lg:bg-contain bg-no-repeat"
          style={{
            backgroundImage: `url('https://res.cloudinary.com/dx6dieevo/image/upload/f_auto,q_auto:good,w_auto/v1724783359/pixa-pie/checkout/rvugydhrgddyb23fejh3.png')`,
            backgroundPosition: 'top center',
          }}
        >
          <div className="text-5xl max-xl:text-4xl max-md:text-3xl max-xs:text-3xl leading-[72px] font-[700] flex w-full justify-center items-center text-center mt-8 congrat-wrapper">
            Congratulations!
          </div>
          <div className="relative flex justify-center text-center items-center text-lg max-md:text-sm mt-2 text-[#000] font-[400] w-full lg:w-[50%] xxl:w-[40%]">
            on becoming a proud Pixa owner! You're in the top 1% of parents
            pioneering AI-driven learning for your child!
          </div>

          <div className="text-3xl max-md:text-xl max-xs:text-xl leading-[72px] font-[700] flex w-full justify-center items-center text-center mt-12 mb-4 congrat-wrapper">
            Here is your Pixa’s birth certificate
          </div>
          <div
            className="min-h-32 w-[80%] max-xl:w-full flex justify-center items-center text-center"
            ref={certificateRef}
          >
            <Certificate issueDate={orderDate} issuedTo={orderedBy} />
            {/* <img src={certificateLink} alt='certificate' className='object-contain object-center w-full h-full' /> */}
          </div>
          <div className="relative flex justify-center text-center items-center text-xl max-md:text-[16px] mt-8 text-[#000] font-[400] w-full lg:w-[50%] xxl:w-[40%]">
            Share this certificate to inspire other parents to join the AI
            education revolution!
          </div>
          <div className="w-full flex flex-col justify-center items-center text-center py-16 max-md:py-8">
            <button
              type="submit"
              title="Download Image"
              className="p-4 congrat-btn flex justify-center items-center text-center flex-row rounded-xl space-x-2 px-6 shadow-inner shadow-white w-[80%] md:w-[50%] lg:w-[40%] xl:w-[30%] xxl:w-[20%]"
              onClick={() => {
                // setShowShareModal(!showShareModal);
                // downloadAccImage();
                downloadHTMLImage();
              }}
            >
              <span className="text-xl max-md:text-sm text-white">
                Download birth certificate
              </span>
            </button>
          </div>
        </div>
        <div className="w-full flex justify-center items-center text-center py-16">
          <button
            type="submit"
            title="home"
            className="p-4 congrat-btn flex justify-center items-center text-center flex-row rounded-xl space-x-2 px-6 shadow-inner shadow-white"
            onClick={() => {
              navigate('/');
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              className="mb-0.5"
            >
              <path
                d="M2 12.204C2 9.915 2 8.771 2.52 7.823C3.038 6.874 3.987 6.286 5.884 5.108L7.884 3.867C9.889 2.622 10.892 2 12 2C13.108 2 14.11 2.622 16.116 3.867L18.116 5.108C20.013 6.286 20.962 6.874 21.481 7.823C22 8.772 22 9.915 22 12.203V13.725C22 17.625 22 19.576 20.828 20.788C19.656 22 17.771 22 14 22H10C6.229 22 4.343 22 3.172 20.788C2.001 19.576 2 17.626 2 13.725V12.204Z"
                stroke="white"
                stroke-width="1.5"
              />
              <path
                d="M9 16C9.85 16.63 10.885 17 12 17C13.115 17 14.15 16.63 15 16"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
            <span className="text-xl text-white">Back to home</span>
          </button>
        </div>
      </div>
      <div
        className="fixed z-[-9999] left-0 top-0 w-full max-w-[1200px]"
        ref={newCertificateRef}
      >
        {/* <CertificateDownload issueDate={orderDate} issuedTo={orderedBy} /> */}
        <div className="cert-container">
          <div className="cert" ref={newCertificateRef}>
            <div className="cert-content">
              <div className="cert-header md:mt-[2%] max-md:mt-[2%]">
                <img
                  src="https://res.cloudinary.com/dx6dieevo/image/upload/f_auto,q_auto:good,w_auto/v1724838523/pixa-pie/certificate/taoenze9vpsz00tgqfhd.png"
                  alt="certificate header 1"
                  className="object-contain max-md:max-h-[9px] max-h-[20px]"
                />
                <span className="cert-title-download font-modern">
                  Birth Certificate
                </span>
                <img
                  src="https://res.cloudinary.com/dx6dieevo/image/upload/f_auto,q_auto:good,w_auto/v1724838523/pixa-pie/certificate/xzwv31rlpnsofpzu44md.png"
                  alt="certificate header 2"
                  className=" object-contain max-md:max-h-[9px] max-h-[20px] mt-[1%]"
                />
              </div>
              <div className="cert-body md:mt-[3%] max-md:mt-[2%]">
                <div className="cert-subtitle text-[#646363] mt-[1%] md:mb-0 lg:text-xl">
                  This certificate grants
                </div>
                <div className="cert-name font-gochi text-[#152056] md:mt-[-2%] max-md:mt-[-2%]">
                  {orderedBy}
                </div>
                <div className="cert-underline mt-[1%]"></div>
                <div className="cert-description text-[#646363] lg:text-xl">
                  holds complete parental rights and responsibilities for Pixa,
                  born on <b>{orderDate}</b>, at Pixa AI Labs. Pixa is known for
                  its cuddly vibes and boundless curiosity
                </div>
                <div className="cert-message  text-[#646363] font-[700] mt-[6%] max-md:mt-[2%] lg:text-[24px]">
                  "Treat Pixa with care and watch as your bond grows!"
                </div>
              </div>
              <div className="cert-footer md:mt-[8%] max-md:mt-[6%]">
                <div className="cert-footer-item">
                  <span className="cert-date font-just text-[#2E3341] font-semibold lg:text-[24px] max-md:text-[10px]">
                    {orderDate}
                  </span>
                  <span className="cert-label">Date</span>
                </div>
                <div className="cert-footer-item">
                  <img
                    src="https://res.cloudinary.com/dx6dieevo/image/upload/f_auto,q_auto:good,w_auto/v1724843312/pixa-pie/certificate/sr3h3gngin25dsmcceew.png"
                    alt="seal"
                    className="cert-seal"
                  />
                </div>
                <div className="cert-footer-item">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 76 32"
                    className="cert-signature"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M14.1067 31.766C10.2894 31.6553 6.36144 30.4935 3.81658 27.8933L2.71012 28.6126L2.54416 28.3359L3.59531 27.6167C2.82078 26.7869 2.21224 25.8464 1.76965 24.7399C0.10996 20.4247 1.99092 15.8329 3.26335 13.5093C8.24242 4.43636 19.2517 -0.764004 29.4312 1.11698C30.3164 1.28295 31.2568 1.55957 31.8654 2.27877C32.6399 3.21926 32.3633 4.65766 32.142 5.37686C31.1462 8.69625 28.1588 10.9645 25.0053 13.1774L24.6734 13.3987C26.3331 14.0626 27.6608 15.0031 28.546 16.2202C30.095 18.3225 30.261 21.3652 29.2099 24.0207C31.8101 24.1867 34.4656 24.0761 37.0104 23.3015C41.215 22.0844 45.4195 18.1565 44.977 13.3434V13.2327C44.9216 12.6795 44.8663 12.0156 45.2536 11.573C45.6962 11.0751 46.4154 11.0751 47.0792 11.1305C56.5948 12.0156 66.221 13.1774 75.6259 14.6158L75.5706 14.9478C66.1657 13.5094 56.5395 12.3476 47.0792 11.4624C46.4707 11.4071 45.8621 11.4071 45.5302 11.7943C45.2536 12.1263 45.2536 12.6795 45.3089 13.1774L45.3642 13.3434C45.7515 18.2671 41.4363 22.3611 37.1211 23.6888C34.5209 24.4633 31.7547 24.574 29.0439 24.3527C28.6567 25.1825 28.1587 26.0124 27.5502 26.7316C24.784 29.885 20.5795 31.1021 17.5367 31.5447C16.4303 31.7106 15.2685 31.766 14.1067 31.766ZM4.09319 27.6721C7.30193 30.9361 12.8896 31.8766 17.4814 31.2127C20.4688 30.7701 24.5627 29.6084 27.2736 26.5103C27.8637 25.8464 28.3431 25.1088 28.712 24.2973C26.7757 24.1867 24.8947 23.8548 23.1243 23.5782C21.1327 23.2462 18.8645 22.9143 17.0388 21.6972C16.3749 21.3099 15.7111 20.7014 15.2132 19.9822L4.09319 27.6721ZM25.7798 1.06165C16.8728 0.840362 7.91051 5.76413 3.59531 13.6753C2.32288 15.9436 0.441885 20.3694 2.10158 24.574C2.54416 25.6804 3.0974 26.5656 3.87192 27.3954L15.0472 19.6502C14.3833 18.5991 14.0514 17.382 14.3833 16.1649C15.1578 13.1774 19.0304 12.0709 22.3498 12.6795C23.0506 12.827 23.696 13.0114 24.2861 13.2327L24.784 12.9008C27.9375 10.6879 30.8143 8.47495 31.8101 5.26621C32.0314 4.60233 32.2526 3.3299 31.5888 2.44473C31.0909 1.83618 30.2057 1.61489 29.3758 1.44892C28.1956 1.22763 26.997 1.09854 25.7798 1.06165ZM15.4898 19.7609C15.9877 20.4247 16.5962 20.978 17.2048 21.4206C18.9751 22.5823 21.2433 22.9143 23.1797 23.2462C25.0053 23.5228 26.8863 23.7995 28.8226 23.9654C29.9291 21.3652 29.7631 18.4884 28.2694 16.3862C27.3842 15.2244 26.0565 14.2286 24.3415 13.62L15.4898 19.7609ZM20.7455 12.9008C18.0346 12.7902 15.3238 13.8966 14.7152 16.2202C14.4386 17.382 14.7153 18.4884 15.3238 19.4842L23.9542 13.454C23.401 13.3065 22.8477 13.159 22.2945 13.0114C21.7781 12.9377 21.2618 12.9008 20.7455 12.9008Z"
                      fill="#2E3341"
                      stroke="#2E3341"
                      strokeWidth="0.434734"
                    />
                  </svg>
                  <span className="cert-label max-md:mt-[-3%]">
                    Pixaverse Studios
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ConfirmationPage;
